/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Dashboard_Model_Showing_Of_ModelsInputs */



/**
* | output |
* | --- |
* | "Showing {shown} of {total} models" |
*
* @param {Dashboard_Model_Showing_Of_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_model_showing_of_models = /** @type {((inputs: Dashboard_Model_Showing_Of_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Model_Showing_Of_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Zeige ${i?.shown} von ${i?.total} Modellen`)
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} models`)
});